import {Loader2Icon, WandSparklesIcon} from "lucide-react";
import {SpellSummary} from "@/spells/model/Spell.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import {HighlightedSearchText} from "@/search/SearchPopover.tsx";
import {displaySpellLevel} from "@/spells/SpellFormatting.ts";
import {getSchoolAttributes} from "@/spells/model/SpellSchools.ts";
import {cn} from "@/lib/utils.ts";

export default function SpellSearchResultEntry({spell, query, onSelect, selecting = false, actionLabel}: {
    spell: SpellSummary;
    query: string;
    onSelect: () => void;
    selecting?: boolean;
    actionLabel?: string;
}) {
    const school = getSchoolAttributes(spell);

    return <button type="button" disabled={selecting}
                   className="flex w-full items-center gap-3 border-l-4 border-l-sky-500 bg-popover px-2 py-1.5 text-left outline-none transition-colors hover:bg-accent/70 focus-visible:ring-3 focus-visible:ring-ring/40 disabled:opacity-60"
                   onClick={onSelect}
                   aria-label={actionLabel ?? spell.name}>
        <span className={cn("flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-sm border bg-white", school.border)}>
            {spell.image
                ? <img draggable="false" className="size-full select-none object-contain" alt="" src={srcUrl(spell.image)}/>
                : <WandSparklesIcon className={cn("size-5", school.text)}/>}
        </span>
        <span className="min-w-0 grow">
            <span className="block truncate font-semibold text-foreground">
                <HighlightedSearchText text={spell.name} query={query}/>
            </span>
            <span className="mt-0.5 flex flex-wrap items-center gap-x-1.5 text-xs text-muted-foreground">
                <span className={school.text}>{school.label}</span>
                <span aria-hidden="true" className="text-border">•</span>
                <span>{displaySpellLevel(spell.level)}</span>
                {spell.ritual && <>
                    <span aria-hidden="true" className="text-border">•</span>
                    <span>Ritual</span>
                </>}
            </span>
        </span>
        {selecting && <Loader2Icon className="mr-1 size-4 animate-spin"/>}
    </button>;
}
